import React, { Component } from "react";
import PropTypes from "prop-types";

class ContentPageTagItem extends Component {
  render() {
    const { name, link } = this.props.tag;
    return (
      <div className="col-12 col-md-11 d-flex flex-wrap pl-md-5">
        <a
          href={link}
          className="link-revert py-4 px-10 mr-10 mb-10 border border-hover"
        >
          {name}
        </a>
      </div>
    );
  }
}

ContentPageTagItem.propTypes = {};

export default ContentPageTagItem;
